/* Keep each fundraiser and regular purchases in separate storefront carts.
   Checkout-level enforcement requires a Shopify cart/checkout validation app.
   Never remove items or retry an add automatically. */
(function () {
  'use strict';
  if (window.greyRidgePACOrders) return;

  var MESSAGE = 'Each fundraiser needs its own order, separate from regular shopping. Please complete your current order or remove those items before starting another.';
  var MIXED_MESSAGE = 'Your cart contains items from different fundraisers or regular shopping. Please keep one group in your cart and place the other order separately.';
  var READ_ERROR = 'We could not check your cart. Please try again before adding an item or continuing to checkout.';
  var html = document.documentElement;
  var originalFetch = window.fetch.bind(window);

  var currentCart = null;
  var queue = Promise.resolve();
  var readPending = null;
  var syncTimer;
  var paintTimer;
  var dialog;
  var replayClicks = new WeakSet();
  var replayForms = new WeakSet();
  var checkingControls = new WeakSet();
  var checkoutLoading = new Map();
  var checkoutSelector = '[name="checkout"], #checkout, .kaching-cart__checkout-button, a[href*="/checkout"]';

  function jsonNode(id, fallback) {
    try { return JSON.parse(document.getElementById(id).textContent); }
    catch (error) { return fallback; }
  }
  var initial = jsonNode('pac-order-state', {});
  var catalog = jsonNode('pac-cart-products', []);
  var initialProducts = (initial.cart || []).slice();
  if (initial.productId) initialProducts.push({id: initial.productId, group: initial.group || 'retail', variants: initial.productVariants || []});
  var rules = window.GreyRidgeFundraiserRules.create(catalog, initialProducts);
  var labels = {'tcs-pac':'TCS PAC', '82-rcacs':'82 RCACS', '9-neepawa-cadets':'#9 Neepawa Cadets'};
  function root() { return window.Shopify?.routes?.root || '/'; }
  function types(items) { return rules.state(items); }
  function state() { return types(currentCart ? currentCart.items : initial.cart || []); }
  function acceptCart(cart) {
    if (!cart || !Array.isArray(cart.items) || typeof cart.item_count !== 'number') return;
    currentCart = cart;
    paint();
  }
  async function readCart() {
    if (readPending) return readPending;
    readPending = (async function () {
      var response = await originalFetch(root() + 'cart.js', {
        credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' },
        signal: AbortSignal.timeout(10000)
      });
      if (!response.ok) throw new Error(READ_ERROR);
      var cart = await response.json();
      if (!Array.isArray(cart.items) || typeof cart.item_count !== 'number') throw new Error(READ_ERROR);
      acceptCart(cart);
      return cart;
    })();
    try { return await readPending; }
    finally { readPending = null; }
  }
  function scheduleSync() {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () { readCart().catch(function () {}); }, 150);
  }
  function serialize(operation) {
    var next = queue.then(operation, operation);
    queue = next.catch(function () {});
    return next;
  }
  function showMessage(message) {
    if (!document.body) return;
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'pac-order-dialog';
      dialog.setAttribute('aria-labelledby', 'pac-order-dialog-title');
      dialog.setAttribute('aria-describedby', 'pac-order-dialog-message');
      dialog.innerHTML = '<h2 id="pac-order-dialog-title">Separate orders, please</h2><p id="pac-order-dialog-message"></p><div class="pac-order-dialog__actions"><button type="button">Review cart</button><button type="button">Continue shopping</button></div>';
      dialog.querySelector('button').addEventListener('click', function (event) {
        event.stopImmediatePropagation();
        window.location.assign(root() + 'cart');
      });
      dialog.querySelector('button:last-child').addEventListener('click', function () { dialog.close(); });
      document.body.append(dialog);
    }
    dialog.querySelector('p').textContent = message;
    if (!dialog.open) dialog.showModal();
  }
  function paint() {
    var cartState = state();
    html.classList.toggle('pac-order-mixed', cartState.mixed);
    html.classList.toggle('pac-order-product-conflict', Boolean(initial.productId && cartState.groups.length && cartState.groups.some(function (key) { return key !== initial.group; })));
    html.classList.toggle('fundraiser-context', cartState.pac || Boolean(initial.pageGroup && initial.pageGroup !== 'retail'));
    html.classList.toggle('fundraiser-cart-active', cartState.pac);
    if (!document.body) return;
    // The app replaces its DOM. Insert one notice per checkout area, without
    // changing the app's buttons, quantities, images, or layout.
    document.querySelectorAll('#main-cart-footer .cart__ctas, .kaching-cart__checkout-button, .mini-cart-body .checkout-btn').forEach(function (target) {
      var notice = target.previousElementSibling;
      if (!notice || !notice.hasAttribute('data-pac-order-notice')) {
        notice = document.createElement('p');
        notice.className = 'pac-order-notice';
        notice.setAttribute('data-pac-order-notice', '');
        notice.setAttribute('role', 'status');
        target.before(notice);
      }
      var currentGroup = cartState.groups.find(function (key) { return key !== 'retail'; });
      var message = cartState.mixed ? MIXED_MESSAGE : (labels[currentGroup] || 'Fundraiser') + ' order. ' + (currentGroup === 'tcs-pac' ? 'School pickup only. ' : currentGroup === '9-neepawa-cadets' ? 'Pickup will be arranged at a future Cadets night. ' : currentGroup === '82-rcacs' ? 'Pickup at the Brandon Armoury on December 5. ' : 'Choose your delivery or pickup option at checkout. ') + 'Please order other groups and regular products separately.';
      if (notice.textContent !== message) notice.textContent = message;
      notice.hidden = !cartState.pac;
    });
    // When a previously mixed cart has been corrected, release only buttons
    // that Liquid disabled specifically for this rule.
    if (cartState.mixed) document.querySelectorAll('#main-cart-footer [name="checkout"]').forEach(function (button) {
      button.setAttribute('data-pac-order-disabled', '');
      if (!button.disabled) button.disabled = true;
    });
    document.querySelectorAll('[data-pac-order-disabled]').forEach(function (button) {
      if (!cartState.mixed) {
        button.disabled = !currentCart || currentCart.item_count === 0;
        button.removeAttribute('data-pac-order-disabled');
      }
    });
    document.querySelectorAll('.kaching-product-upsell-item').forEach(function (item) {
      var itemGroup = rules.group({ product_id: item.dataset.productId, title: item.querySelector('.kaching-product-upsell-item__title')?.textContent || '' });
      // Hide incompatible suggestions. Existing shopper-selected lines stay.
      var blocked = cartState.groups.some(function (key) { return key !== itemGroup; });
      if (blocked) {
        item.setAttribute('data-pac-order-hidden', '');
        item.style.setProperty('display', 'none', 'important');
      } else if (item.hasAttribute('data-pac-order-hidden')) {
        item.removeAttribute('data-pac-order-hidden');
        item.style.removeProperty('display');
      }
    });
  }
  function endpoint(input) {
    try {
      var url = new URL(input instanceof Request ? input.url : String(input), location.href);
      if (url.origin !== location.origin) return '';
      return url.pathname.match(/\/cart\/(add|update|change|clear)(?:\.js)?\/?$/i)?.[1] || '';
    } catch (error) { return ''; }
  }
  function parseBody(body) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      var data = {};
      var indexedItems = {};
      for (var entry of body.entries()) {
        var key = entry[0], value = entry[1];
        var match = key.match(/^items\[(\d+)\]\[(id|quantity)\]$/);
        if (match) {
          indexedItems[match[1]] = indexedItems[match[1]] || {};
          indexedItems[match[1]][match[2]] = value;
        } else if (key === 'updates[]') {
          if (!Array.isArray(data.updates)) data.updates = [];
          data.updates.push(value);
        } else if (/^updates\[.+\]$/.test(key)) {
          data.updates = data.updates || {};
          data.updates[key.slice(8, -1)] = value;
        } else if (key === 'id' || key === 'quantity' || key === 'line') data[key] = value;
      }
      if (Object.keys(indexedItems).length) data.items = Object.values(indexedItems);
      return data;
    }
    if (typeof body === 'string') {
      try { return JSON.parse(body); }
      catch (error) { return parseBody(new URLSearchParams(body)); }
    }
    return {};
  }
  async function fetchBody(input, options) {
    if (options && options.body != null) return parseBody(options.body);
    if (input instanceof Request) {
      var clone = input.clone();
      return parseBody((clone.headers.get('content-type') || '').includes('multipart/form-data') ? await clone.formData() : await clone.text());
    }
    return {};
  }
  function conflicts(cart, operation, data) { return rules.conflicts(cart, operation, data); }
  async function rejection(operation, data) {
    if (operation !== 'add' && operation !== 'update' && operation !== 'change') return null;
    var cart;
    try { cart = await readCart(); }
    catch (error) { return READ_ERROR; }
    return conflicts(cart, operation, data) ? (types(cart.items).mixed ? MIXED_MESSAGE : MESSAGE) : null;
  }
  async function settleResponse(response) {
    if (response.ok) {
      try {
        var result = await response.clone().json();
        if (typeof result.item_count === 'number') acceptCart(result);
        else await readCart();
      } catch (error) { scheduleSync(); }
    }
    return response;
  }
  window.fetch = function (input, options) {
    var operation = endpoint(input);
    if (!operation) return originalFetch(input, options);
    var body = fetchBody(input, options);
    return serialize(async function () {
      var message = await rejection(operation, await body);
      if (message) {
        showMessage(message);
        return new Response(JSON.stringify({ status: 422, message: 'Separate orders required', description: message }), {
          status: 422, headers: { 'Content-Type': 'application/json' }
        });
      }
      return settleResponse(await originalFetch(input, options));
    });
  };

  // Some legacy widgets use jQuery/XHR instead of fetch. Preserve that transport
  // for permitted requests; report a normal transport error for a blocked send.
  var nativeOpen = XMLHttpRequest.prototype.open;
  var nativeSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url, async) {
    this.__pacOrderOperation = endpoint(url);
    this.__pacOrderAsync = async !== false;
    return nativeOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    var xhr = this, operation = xhr.__pacOrderOperation;
    if (!operation || !xhr.__pacOrderAsync) return nativeSend.apply(xhr, arguments);
    serialize(async function () {
      var message = await rejection(operation, parseBody(body));
      if (message) {
        showMessage(message);
        xhr.abort();
        xhr.dispatchEvent(new ProgressEvent('error'));
        xhr.dispatchEvent(new ProgressEvent('loadend'));
        return;
      }
      await new Promise(function (resolve, reject) {
        xhr.addEventListener('loadend', function () { scheduleSync(); resolve(); }, { once: true });
        try { nativeSend.call(xhr, body); } catch (error) { reject(error); }
      });
    }).catch(function () { scheduleSync(); });
  };

  function stop(event) { event.preventDefault(); event.stopImmediatePropagation(); }
  function checkoutButton(control) {
    if (control?.matches?.('#main-cart-footer .cart__checkout-button')) return control;
    if (control instanceof HTMLFormElement) {
      return document.querySelector('#main-cart-footer .cart__checkout-button[form="' + control.id + '"]');
    }
    return null;
  }
  function finishCheckoutLoading(button) {
    if (!button || !checkoutLoading.has(button)) return;
    clearTimeout(checkoutLoading.get(button));
    checkoutLoading.delete(button);
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
    var spinner = button.querySelector('.cart__checkout-loading');
    if (spinner) spinner.hidden = true;
  }
  function startCheckoutLoading(control) {
    var button = checkoutButton(control);
    if (!button) return;
    if (checkoutLoading.has(button)) return;
    // Keep the native submit button enabled: its checkout name must remain in
    // the form submission. The guard below prevents repeated clicks instead.
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    var spinner = button.querySelector('.cart__checkout-loading');
    if (spinner) spinner.hidden = false;
    checkoutLoading.set(button, setTimeout(function () {
      finishCheckoutLoading(button);
    }, 30000));
  }
  async function checkoutAllowed() {
    try {
      await queue;
      var cart = await readCart();
      if (types(cart.items).mixed) { showMessage(MIXED_MESSAGE); return false; }
      if (rules.missingDetails(cart.items)) { showMessage('An item is missing its fundraiser order details. Remove that item and add it again from its product page before checking out.'); return false; }
      return true;
    } catch (error) { showMessage(READ_ERROR); return false; }
  }
  window.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var target = event.target.closest(checkoutSelector);
    if (!target || target.disabled || replayClicks.has(target)) return;
    stop(event);
    if (checkingControls.has(target) || checkoutLoading.has(target)) return;
    checkingControls.add(target);
    startCheckoutLoading(target);
    var continuing = false;
    checkoutAllowed().then(function (allowed) {
      if (allowed && target.isConnected) {
        replayClicks.add(target);
        if (target.form) replayForms.add(target.form);
        try { target.click(); continuing = true; }
        finally { replayClicks.delete(target); if (target.form) replayForms.delete(target.form); }
      }
    }).finally(function () {
      checkingControls.delete(target);
      if (!continuing) finishCheckoutLoading(checkoutButton(target));
    });
  }, true);
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) || replayForms.has(form)) return;
    var action = new URL(form.action, location.href).pathname;
    var isCheckout = /\/checkout\/?$/.test(action) || /\/cart\/?$/.test(action) && (event.submitter?.name === 'checkout' || form.querySelector('input[name="checkout"]'));
    if (!isCheckout) return;
    stop(event);
    if (checkingControls.has(form)) return;
    checkingControls.add(form);
    var button = checkoutButton(event.submitter || form);
    if (checkoutLoading.has(button)) { checkingControls.delete(form); return; }
    startCheckoutLoading(button);
    var continuing = false;
    checkoutAllowed().then(function (allowed) {
      if (allowed) {
        replayForms.add(form);
        try { form.requestSubmit(event.submitter || undefined); continuing = true; }
        finally { replayForms.delete(form); }
      }
    }).finally(function () {
      checkingControls.delete(form);
      if (!continuing) finishCheckoutLoading(button);
    });
  }, true);

  function ready() {
    paint();
    scheduleSync();
    new MutationObserver(function (records) {
      if (!records.some(function (record) { return record.addedNodes.length || record.type === 'attributes'; })) return;
      clearTimeout(paintTimer);
      paintTimer = setTimeout(paint, 60);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready);
  else ready();
  window.addEventListener('pageshow', function () {
    checkoutLoading.forEach(function (timer, button) { finishCheckoutLoading(button); });
    scheduleSync();
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) scheduleSync(); });
  document.addEventListener('cart:refresh', scheduleSync);
  document.addEventListener('fsb:cart-changed', scheduleSync);
  paint();
  window.greyRidgePACOrders = { refresh: readCart };
})();
